export const API_URL = 'https://api-khothi-cms.buso.asia';

export const VITE_STRIPE_PUBLIC_KEY = 'pk_test_51Ib13qDxgEMKmPxXhaaMAsTiPQWw3IF9SIUMcpVQEJlRvoSJog5DLdCsWC66V8tOZPXrsGysxXIPXRIx0j4qRnNQ00OPbcZDc7'

// Supabase Realtime cho phòng chat. Để trống nếu chưa dùng -> phòng chat tự
// fallback về cơ chế polling cũ (không thay đổi hành vi hiện tại).
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://api.maximus-nhon.online';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE5MzczODE0NTgsImlhdCI6MTc3OTcwMTQ1OCwiaXNzIjoic3VwYWJhc2UiLCJyb2xlIjoiYW5vbiJ9.fPmX2xKZ5cttMDAtBTIS6nY0c_w5FTdLGLe9ZltvvGU';

// Khi đã bật Realtime, mặc định vẫn chạy thêm polling chậm (20s/30s) dự phòng
// lúc websocket rớt. Đặt false để TẮT HẲN poll dự phòng (chỉ dựa vào Realtime).
// Không ảnh hưởng tới polling 3s khi CHƯA cấu hình Realtime.
export const REALTIME_FALLBACK_POLL = (process.env.REACT_APP_REALTIME_FALLBACK_POLL || 'false') !== 'false';
